import { useTranslation } from "react-i18next";
import { LeadForm } from "./LeadForm";

export const FinalCTASection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-8 md:py-12 bg-gradient-to-b from-primary/5 to-primary/5">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto text-center mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-foreground mb-4">
            {t("Join")}{" "}
            <span className="text-primary">{t("1000+ Happy Retailers")}</span>{" "}
            {t("Across Egypt")}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-muted-foreground">
            {t(
              "Stop wasting time on complicated systems. myGINNE makes retail simple, fast, and profitable."
            )}
          </p>
        </div>

        <div className="max-w-[63rem] mx-auto text-center px-2" id="lead-form">
          <div className="bg-white rounded-2xl md:rounded-3xl p-3 md:p-4">
            <LeadForm />
            <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-xs sm:text-sm text-muted-foreground">
              <span className="flex items-center gap-2">
                ✓ {t("No credit card required")}
              </span>
              <span className="hidden sm:inline">•</span>
              <span className="flex items-center gap-2">
                ✓ {t("Free setup assistance")}
              </span>
              <span className="hidden sm:inline">•</span>
              <span className="flex items-center gap-2">
                ✓ {t("Start selling in 10 minutes")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
